const KNOWLEDGE = {
  CREATE: 'knowledge-service/knowledge-base/create-empty',
  INIT: 'knowledge-service/knowledge-base/init',
  UPDATE: 'knowledge-service/knowledge-base/update',
  SEARCH: 'knowledge-service/knowledge-base/search',
  DETAIL: 'knowledge-service/knowledge-base/detail',
  DELETE: 'knowledge-service/knowledge-base/delete',
  UPLOAD_FILE: 'knowledge-service/knowledge-base/upload-file',
  STORAGE_CHECK: 'knowledge-service/knowledge/users/storage/check',
}

const KNOWLEDGE_DOCUMENT = {
  CREATE_BY_TEXT: 'knowledge-service/knowledge-document/create-by-text',
  UPDATE_BY_TEXT: 'knowledge-service/knowledge-document/update-by-text',
  CREATE_BY_FILE: 'knowledge-service/knowledge-document/create-from-file',
  UPDATE_BY_FILE: 'knowledge-service/knowledge-document/update-by-file',
  DELETE: 'knowledge-service/knowledge-document/delete',
  SEARCH: 'knowledge-service/knowledge-document/get-list-of-knowledge-base',
  DETAIL: 'knowledge-service/knowledge-document/detail',
  RENAME: 'knowledge-service/knowledge-document/rename',
  CHANGE_STATUS: 'knowledge-service/knowledge-document/change-status',
  GET_LIST_OF_KNOWLEDGE_DOCUMENT_BY_KNOWLEDGE_BASE: 'knowledge-service/knowledge-document/get-list-group-by-knowledge_base',
}

const KNOWLEDGE_CHUNK = {
  PREVIEW_CHUNK: 'knowledge-service/knowledge-chunk/preview-chunks',
  GET_CHUNKS_FROM_DOCUMENT: 'knowledge-service/knowledge-chunk/get-chunks-from-document',
  ADD_CHUNK_TO_DOCUMENT: 'knowledge-service/knowledge-chunk/add-chunk-to-document',
  UPDATE_CHUNK_IN_DOCUMENT: 'knowledge-service/knowledge-chunk/update-chunk-in-document',
  DELETE_CHUNK_FROM_DOCUMENT: 'knowledge-service/knowledge-chunk/delete-chunk-from-document',
  CHANGE_STATUS_CHUNK: 'knowledge-service/knowledge-chunk/change-status-chunk',
}

const OCR = {
  UPLOAD_FILE: 'dify-service/dify-file/upload',
  PROCESS_OCR: 'knowledge-service/knowledge-ocr/workflow/run-with-upload-id',
  CREATE_OCR: 'knowledge-service/knowledge-ocr/create',
  DETAIL_OCR: 'knowledge-service/knowledge-ocr/getDetail',
  DELETE_OCR: 'knowledge-service/knowledge-ocr/delete',
  LIST_OCR: 'knowledge-service/knowledge-ocr/listKnowledgeOcr',
  UPDATE_OCR: 'knowledge-service/knowledge-ocr/update',
  EXPORT_CONTENT_OCR: 'knowledge-service/knowledge-ocr/export-content',
}

const AGENTS = {
  DETAIL: 'agents-service/agents',
  GENERATE_AGENT: 'agents-service/agents/generate-agent-param-from-prompt-text',
  GET_LST_DEFAULT_CLASSROOM_AGENT: 'agents-service/agents/get-lst-default-classroom-agent',
  PULL_DEFAULT_CLASSROOM_AGENTS: 'agents-service/workspace-folder-classroom-agent-mapping/pull-default-classroom-agents',
  GET_LST_DEFAULT_CLASSROOM_AGENT_FOR_USER: 'agents-service/workspace-folder-classroom-agent-mapping/get-lst-default-classroom-agent-for-user',
  GET_LIST_AGENT_TASK: 'agents-service/task-process/init',
}

const KNOWLEDGE_CHILD_CHUNK = {
  ADD_CHILD_CHUNK: 'knowledge-service/knowledge-child-chunk/add-child-chunk',
  UPDATE_CHILD_CHUNK: 'knowledge-service/knowledge-child-chunk/update-child-chunk',
  GET_LIST_CHILD_CHUNK: 'knowledge-service/knowledge-child-chunk/get-list-child-chunk',
  DELETE_CHILD_CHUNK: 'knowledge-service/knowledge-child-chunk/delete-child-chunk',
}

const KNOWLEDGE_METADATA = {
  CREATE_KNOWLEDGE_METADATA: 'knowledge-service/knowledge-metadata/create-knowledge-metadata',
  UPDATE_KNOWLEDGE_METADATA: 'knowledge-service/knowledge-metadata/update-knowledge-metadata',
  DELETE_KNOWLEDGE_METADATA: 'knowledge-service/knowledge-metadata/delete-knowledge-metadata',
  UPDATE_STATUS_KNOWLEDGE_METADATA: 'knowledge-service/knowledge-metadata/update-status-knowledge-metadata',
  GET_LIST_KNOWLEDGE_METADATA: 'knowledge-service/knowledge-metadata/get-list-knowledge-metadata',
  ASSIGN_METADATA_FOR_KNOWLEDGE_DOCUMENT: 'knowledge-service/knowledge-metadata/assign-metadata-for-knowledge-document',
  GET_LIST_METADATA__FOR_KNOWLEDGE_DOCUMENT: 'knowledge-service/knowledge-metadata/get-list-metadata-for-knowledge-document',
}
const TASK = {
  CREATE: 'agents-service/task/create',
  RENDER_PROMPT: 'agents-service/task/render_prompt',
  GET_VARIABLE: 'agents-service/task/get_variable',
  GET_LIST: 'agents-service/task/get_list',
  DELETE: 'agents-service/task/delete',
  UPDATE: 'agents-service/task/update',
  GET_LIST_TAG: 'agents-service/task/get_list_tag',
  CREATE_TAG: 'agents-service/task/create_tag',
  ASSIGN_AGENT: 'agents-service/task/assign_agent',
  DELETE_TAG: 'agents-service/task/delete_tag',
  UPDATE_TAG: 'agents-service/task/update_tag',
  GET_TASK_AND_AGENT: 'agents-service/task/get_task_and_agent',
  PARSE_VARIABLE_CREATE: 'agents-service/task/task/parse-variable',
  PARSE_VARIABLE_UPDATE: 'agents-service/task/parse-variable/update',
  SAVE_TASK: 'agents-service/task/save-task',
}

const FILE = {
  DOWNLOAD: 'knowledge-service/file/download',
  GET_PATH: 'knowledge-service/file/get-path',
}

const AGENT_SKILL = {
  LIST: 'agents-service/agent-skill/list',
}

const AGENT_SKILL_MAPPING = {
  LIST: 'agents-service/agent-skill-mapping/list',
  ASSIGN_SKILL_TO_AGENT: 'agents-service/agent-skill-mapping/assign-skills-to-agent',
}

const CLASSROOM = {
  CREATE: 'classroom-service/classroom/create',
  LIST: 'classroom-service/classroom/list',
  DETAIL: 'classroom-service/classroom/detail',
  UPDATE: 'classroom-service/classroom/update',
  DELETE: 'classroom-service/classroom/delete',
}

const CLASSROOM_LEARNING_SPACE = {
  CREATE: 'classroom-service/learning-space/create',
  LIST: 'classroom-service/learning-space/list',
  DETAIL: 'classroom-service/learning-space/detail',
  UPDATE: 'classroom-service/learning-space/update',
  DELETE: 'classroom-service/learning-space/delete',
  CREATE_AUTO: 'classroom-service/learning-space/create-auto',
}

const CLASSROOM_STUDENT = {
  CREATE: 'classroom-service/classroom-student/add-students-to-classroom',
  DELETE: 'classroom-service/classroom-student/remove-student-from-classroom',
  LIST: 'classroom-service/classroom-student/get-students-in-classroom',
  CREATE_LINK: 'classroom-service/classroom-student/create-link',
  TOKEN: 'classroom-service/classroom-student/token',
  LIST_STUDENT: 'classroom-service/classroom-student/list-student',
  ADD_STUDENT: 'classroom-service/classroom-student/add-student',
  LIST_CLASSROOM: 'classroom-service/classroom-student/list-classroom',
  GET_STUDENT: 'classroom-service/classroom-student/get-student',
  CANCEL_REQUEST: 'classroom-service/classroom-student/cancel-the-request',
}

const CLASSROOM_LEARNING_SPACE_AGENT = {
  CREATE: 'classroom-service/learning-space-agent/assign-agents-for-learning-space',
  LIST_ALL_AGENT: 'classroom-service/learning-space-agent/get-learning-space-agents',
  LIST_AGENT: 'classroom-service/learning-space-agent/get-agents-in-learning-space',
  DELETE: 'classroom-service/learning-space-agent/delete-agent-from-learning-space',
}

const CLASSROOM_LESSON = {
  CREATE: 'classroom-service/lesson/create',
  LIST: 'classroom-service/lesson/list',
  DETAIL: 'classroom-service/lesson/detail',
  UPDATE: 'classroom-service/lesson/update',
  DELETE: 'classroom-service/lesson/delete',
}
const CLASSROOM_EXERCISE = {
  CREATE: 'classroom-service/exercise/create',
  LIST: 'classroom-service/exercise/list',
  DETAIL: 'classroom-service/exercise/detail',
  UPDATE: 'classroom-service/exercise/update',
  DELETE: 'classroom-service/exercise/delete',
  UPDATE_STATUS: 'classroom-service/exercise/update-status-exercises',
  ANSWER: 'classroom-service/student-answer/list',
  GET_LIST_GROUP_BY_LESSON: 'classroom-service/exercise/get-list-group-by-lesson',
  EXPORT: 'classroom-service/exercise/exercise-export',
}

const WORKSPACE = {
  LIST_EMAIL: 'agents-service/workspaces/list_email_workspace',
  LIST_WORKSPACE_ADMIN: 'agents-service/workspaces/list-workspace-admin',
  UPDATE_WORKSPACE_ADMIN: 'agents-service/workspaces/update/admin',
  DELETE_WORKSPACE_ADMIN: 'agents-service/workspaces/delete_account',
  SHARE_ADMIN: 'agents-service/workspaces/share-admin',
  GET_APPROVED_ACCOUNT: 'agents-service/workspaces/get-approved-account',
  UPDATE_APPROVED_ACCOUNT: 'agents-service/workspaces/update-approved-account',
  GET_WORKSPACE_PENDING: 'agents-service/workspaces/get-workspace-pending',
  DELETE_WORKSPACE_BY_ACCOUNT: 'agents-service/workspaces/delete-workspace-by-account',
  LIST_ALL_WORKSPACE: 'agents-service/workspaces/list-all-workspace',

}
const CLASSROOM_QUESTION = {
  CREATE: 'classroom-service/question/create',
  LIST: 'classroom-service/question/list',
  DETAIL: 'classroom-service/question/detail',
  UPDATE: 'classroom-service/question/update',
  DELETE: 'classroom-service/question/delete',
  GENERATE: 'classroom-service/question/generate',
  GENERATE_EXAM: 'classroom-service/question/generate-exam',
}

const EXERCISE = {
  DETAIL_INFO_LIST: 'classroom-service/exercise/get-exercise-detail-info-list',
  LIST_OF_STUDENT: 'classroom-service/exercise/get-lst-exercise-of-student',
  SUBMIT: 'classroom-service/student-exercise-submit/submit-exercise',
  SUBMIT_DETAIL: 'classroom-service/student-exercise-submit/detail',
  GRADE_EXERCISE: 'classroom-service/student-exercise-submit/grade-exercise',
  GRADE_EXERCISE_MANUALLY: 'classroom-service/student-exercise-submit/grade-exercise-manually',
  GET_LIST_STUDENT_EXERCISE_SUBMIT_PROGRESS: 'classroom-service/student-exercise-submit/get-list-student-exercise-submit-progress',
  SUMMARISE_CLASSROOM_RESULT: 'classroom-service/student-exercise-submit/summarize-classroom-results',
  GET_LIST_EX_RESULT_FOR_STUDENT: 'classroom-service/student-exercise-submit/get-list-ex-result-for-student',
}

const CLASSROOM_LESSON_DOCUMENT = {
  CREATE: 'classroom-service/lesson-document/create',
  CREATE_BY_FILE: 'classroom-service/lesson-document/create-by-file',
  LIST: 'classroom-service/lesson-document/list',
  DETAIL: 'classroom-service/lesson-document/detail',
  UPDATE: 'classroom-service/lesson-document/update',
  DELETE: 'classroom-service/lesson-document/delete',
  GENERATE: 'classroom-service/lesson-document/generate',
  UPDATE_STATUS: 'classroom-service/lesson-document/update-status-lesson-documents',
}

const CLASSROOM_LESSON_PLAN = {
  CREATE: 'classroom-service/lesson_plan/create',
  CREATE_BY_FILE: 'classroom-service/lesson_plan/create-by-file',
  LIST: 'classroom-service/lesson_plan/list',
  DETAIL: 'classroom-service/lesson_plan/detail',
  UPDATE: 'classroom-service/lesson_plan/update',
  DELETE: 'classroom-service/lesson_plan/delete',
  GET_LIST_GROUP_BY_CLASSROOM: 'classroom-service/lesson_plan/get-list-group-by-classroom',
}

const AGENT_PDF = {
  GET_AGENT_PDF_FOR_USER: 'agents-service/agent-pdf/get-for-user',
  CREATE_AGENT_PDF: 'agents-service/agent-pdf/create',
}

const CLASSROOM_TEACHING_PLAN = {
  CREATE: 'classroom-service/teaching_plan/create',
  LIST: 'classroom-service/teaching_plan/list',
  DETAIL: 'classroom-service/teaching_plan/detail',
  UPDATE: 'classroom-service/teaching_plan/update',
  DELETE: 'classroom-service/teaching_plan/delete',
  GET_LIST_GROUP_BY_CLASSROOM: 'classroom-service/teaching_plan/get-list-group-by-classroom',
  GET_LIST_DOCUMENT: 'agents-service/document/list',
}

const CLASSROOM_QUESTION_BANK = {
  LIST: 'classroom-service/question-bank/list',
  DETAIL: 'classroom-service/question-bank/detail',
  DELETE: 'classroom-service/question-bank/delete',
}

const CLASSROOM_EXAM_TEMPLATE = {
  CREATE: 'classroom-service/exam-template/create',
  LIST: 'classroom-service/exam-template/list',
  DETAIL: 'classroom-service/exam-template/detail',
  UPDATE: 'classroom-service/exam-template/update',
  DELETE: 'classroom-service/exam-template/delete',
  CLONE: 'classroom-service/exam-template/clone',
}

const CLASSROOM_EXAM = {
  CREATE: 'classroom-service/exam/create',
  LIST: 'classroom-service/exam/list',
  LIST_FOR_STUDENT: 'classroom-service/exam/get-list-for-student',
  DETAIL: 'classroom-service/exam/detail',
  DETAIL_FOR_STUDENT: 'classroom-service/exam/detail-for-student',
  UPDATE: 'classroom-service/exam/update',
  DELETE: 'classroom-service/exam/delete',
  GET_EXAM_SUBMIT_SUMMARY_INFO: 'classroom-service/exam/get-exam-submit-summary-info',
}

const WORKSPACE_SHARE_GROUP = {
  CREATE: 'agents-service/workspace-share-group/create',
  LIST: 'agents-service/workspace-share-group/list',
  DETAIL: 'agents-service/workspace-share-group/detail',
  UPDATE: 'agents-service/workspace-share-group/update',
  DELETE: 'agents-service/workspace-share-group/delete',
  ASSIGN_GROUP_FOR_STUDENTS: 'agents-service/workspace-share-group/assign-group-for-students',
}

const CLASSROOM_AGENT = {
  CREATE: 'classroom-service/classroom-agent/assign-agents-for-classroom',
  LIST_ALL_AGENT: 'classroom-service/classroom-agent/get-classroom-agents',
  LIST_AGENT: 'classroom-service/classroom-agent/get-agents-in-classroom',
  DELETE: 'classroom-service/classroom-agent/delete-agent-from-classroom',
}

const CLASSROOM_FILE_HISTORY = {
  LIST: 'classroom-service/classroom-function-file-history/get-all',
  DELETE_HISTORY: 'classroom-service/classroom-function-file-history/delete-history',
}

const CLASSROOM_USER_FUNCTION_PINNED = {
  LIST: 'users-service/user-function-pinned/list',
  PIN: 'users-service/user-function-pinned/pin',
  UNPIN: 'users-service/user-function-pinned/unpin',
  SAVE: 'users-service/user-function-pinned/save',
}

const TENANTS = {
  LIST: 'dify-service/tenants',
}
const AUTH = {
  CREATE_USER: 'auth/create_user',
  VERIFY_EMAIL: 'auth/verifyEmail',
  UPDATE_USER_SYSTEM: 'auth/updateUserSystem',
  SEND_MAIL_FOR_ADMIN: 'auth/sendMailForAdmin',
  OTP_FOR_EMAIL: 'auth/optForEmail',
  VERIFY_OTP: 'auth/verifyOtp',
  FORGOT_PASSWORD: 'auth/forgotPassword',
  CHECK_ACCOUNT: 'auth/check-account',
  SET_ACCOUNT_GOOGLE: 'auth/set-account-google',
  UPDATE_PASSWORD: 'auth/update-password',
  CREATE_USER_ADMIN: 'auth/create-user-admin',
}

const USER = {
  LIST_PROVINCE: 'users-service/province/list-province',
  LIST_DISTRICT: 'users-service/province/list-district',
  LIST_BY_ROLE: 'users-service/users/list-by-role',
  LIST_ALL: 'users-service/users/list-all',
}

const CHAT = {
  SEARCH: 'interactions-service/conversations/search',
}

const IMAGE_SHARE_COMMUNITY = {
  SHARE: 'agents-service/image-share-community/share',
  APPROVE: 'agents-service/image-share-community/approve',
  LIST: 'agents-service/image-share-community/list',
  DETAIL: 'agents-service/image-share-community/detail',
  LIKE: 'agents-service/image-share-community/like',
  DELETE: 'agents-service/image-share-community/delete',
}

const VIEW_USER_CREATE = {
  LIST_USER_BILLING: 'billing-service/api/v1/view_user_credit/list-user-billing',
  UPDATE_USER_CREDIT: 'billing-service/api/v1/view_user_credit/update-user-credit',
  UPDATE_WORKSPACE_CREDIT: 'billing-service/api/v1/view_user_credit/update-workspace-credit',
}

const PACKAGES = {
  LIST: 'billing-service/api/v1/packages/list',
  CREATE: 'billing-service/api/v1/packages/',
  DETAIL: 'billing-service/api/v1/packages/',
  UPDATE: 'billing-service/api/v1/packages/',
  DELETE: 'billing-service/api/v1/packages/delete',
  EXCEL: 'billing-service/api/v1/packages/excel',
}

export {
  KNOWLEDGE,
  KNOWLEDGE_DOCUMENT,
  AGENTS,
  KNOWLEDGE_CHUNK,
  KNOWLEDGE_CHILD_CHUNK,
  KNOWLEDGE_METADATA,
  TASK,
  FILE,
  OCR,
  AGENT_SKILL,
  AGENT_SKILL_MAPPING,
  CLASSROOM,
  CLASSROOM_LEARNING_SPACE,
  CLASSROOM_STUDENT,
  CLASSROOM_LEARNING_SPACE_AGENT,
  CLASSROOM_LESSON,
  CLASSROOM_EXERCISE,
  WORKSPACE,
  CLASSROOM_QUESTION,
  CLASSROOM_LESSON_DOCUMENT,
  CLASSROOM_LESSON_PLAN,
  EXERCISE,
  AGENT_PDF,
  CLASSROOM_TEACHING_PLAN,
  CLASSROOM_QUESTION_BANK,
  CLASSROOM_EXAM_TEMPLATE,
  CLASSROOM_EXAM,
  WORKSPACE_SHARE_GROUP,
  CLASSROOM_AGENT,
  CLASSROOM_FILE_HISTORY,
  CLASSROOM_USER_FUNCTION_PINNED,
  TENANTS,
  AUTH,
  USER,
  CHAT,
  IMAGE_SHARE_COMMUNITY,
  VIEW_USER_CREATE,
  PACKAGES,
}
